import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { useParams } from 'react-router-dom';
import { convert } from '../../utils/convertDate';
import WakanowServices from '../../services/wakanowServices';
import BackButton from '../../components/BackButton';

const ViewHolidayPackageRequest = () => {
    const { id } = useParams();
    const [requestData, setRequestData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await WakanowServices.getHolidayPackageRequestById(id);
                if (response) {
                    setRequestData(response.data);
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id]);

    if (isLoading) {
        return (
            <Layout title="Holiday Package Request" pageTag={"wakanow"} current={'/wakanow/holiday-package-requests'}>
                <div className="min-h-full">
                    <div className="flex flex-1 flex-col">
                        <main className="flex-1">
                            <div className="py-6">
                                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                                    <div className="bg-white shadow sm:rounded-lg">
                                        <div className="px-4 py-5 sm:p-6">
                                            <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
                                                {Array.from({ length: 6 }).map((_, index) => (
                                                    <div key={index}>
                                                        <div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-2"></div>
                                                        <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </Layout>
        )
    }

    if (!requestData) {
        return (
            <Layout title="Holiday Package Request" pageTag={"wakanow"} current={'/wakanow/holiday-package-requests'}>
                <div className="text-center py-12">
                    <p className="text-gray-500">Request not found</p>
                </div>
            </Layout>
        )
    }

    return (
        <Layout title="Holiday Package Request" pageTag={"wakanow"} current={'/wakanow/holiday-package-requests'}>
            <React.Fragment>
                <div className="min-h-full">
                    <div className="flex flex-1 flex-col">
                        <BackButton />
                        <main className="flex-1">
                            <div className="py-6">
                                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                                    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                                        <div className="px-4 py-5 sm:p-6">
                                            <dl className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Email Address</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">{requestData.emailAddress}</dd>
                                                </div>
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Status</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">{requestData.status}</dd>
                                                </div>
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Adults</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">{requestData.adults}</dd>
                                                </div>
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Children</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">{requestData.children}</dd>
                                                </div>
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Preferred Travel Date</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">
                                                        {requestData.preferredTravelDate ? convert(requestData.preferredTravelDate) : 'N/A'}
                                                    </dd>
                                                </div>
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Wakanow Handle Flight Booking</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">
                                                        {requestData.allowWakanowHandleFlightBooking ? 'Yes' : 'No'}
                                                    </dd>
                                                </div>
                                                {requestData.comments && (
                                                    <div className="sm:col-span-2">
                                                        <dt className="text-sm font-medium text-gray-500">Comments</dt>
                                                        <dd className="mt-1 text-sm text-gray-900">{requestData.comments}</dd>
                                                    </div>
                                                )}
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Date Created</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">
                                                        {requestData.dateCreated ? convert(requestData.dateCreated) : 'N/A'}
                                                    </dd>
                                                </div>
                                                {requestData.dateModified && (
                                                    <div>
                                                        <dt className="text-sm font-medium text-gray-500">Date Modified</dt>
                                                        <dd className="mt-1 text-sm text-gray-900">
                                                            {convert(requestData.dateModified)}
                                                        </dd>
                                                    </div>
                                                )}
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Package Name</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">{requestData.packageName || 'N/A'}</dd>
                                                </div>
                                                <div>
                                                    <dt className="text-sm font-medium text-gray-500">Destination</dt>
                                                    <dd className="mt-1 text-sm text-gray-900">{requestData.destination || 'N/A'}</dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </React.Fragment>
        </Layout>
    )
}

export default ViewHolidayPackageRequest
